export default "__VITE_ASSET__a44caf6b__"